/* Code generated with AutoHTML Plugin for Figma */

import { FC } from "react";
import {
  _clear,
  _size,
  _style
} from "../../core/core";
import "./button.css";

interface ButtonProps {
  size?: _size;
  style?: _style;
  clear?: _clear;
  icon_left?: React.ReactNode;
  icon_right?: React.ReactNode;
  className?: string;
  width?: string | number | null;
  isMobileWidth?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children?: React.ReactNode;
}

export const Button: FC<ButtonProps> = ({
  size = _size.S,
  style = _style.primary,
  clear = _clear,
  icon_left = null,
  icon_right = null,
  className = "",
  width = null,
  isMobileWidth = false,
  onClick = undefined,
  children,
  ...props
}) => {
  const variantsStyle = (): React.CSSProperties => {
    if (width) {
      return { width };
    } else {
      return {};
    }
  };

  const variantsClassName = `button button-${size} button-${style} btn-icon-${icon_left !== null
    } button-width-${isMobileWidth} ${className}`;

  return (
    <button
      style={variantsStyle()}
      onClick={onClick}
      className={variantsClassName}
      {...props}
    >
      {icon_left}
      {children && (
        <div className={`btn-text btn-text-${size} btn-text-${style}`}>
          {children}
        </div>
      )}
      {icon_right}
    </button>
  );
};
